module.exports = __webpack_public_path__ + "img/key.30856f6b.svg";